var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    _setup.Step,
    {
      staticClass: "matching-step",
      attrs: {
        title: _vm.title,
        description: _setup.description,
        id: _setup.id,
        component: _setup.component,
      },
    },
    [
      _setup.initialized
        ? _c(
            "div",
            { staticClass: "matching-step-wrapper" },
            [
              _c(_setup.FullScreenToggle, {
                staticClass: "full-screen-toggle",
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (fullScreenSlotProps) {
                        return [
                          _c(
                            _setup.Toolbar,
                            [
                              _c("div", { staticClass: "grow" }),
                              _vm._v(" "),
                              _c(_setup.Action, {
                                staticClass: "enum-mr-4 enum-my-2",
                                attrs: { icon: "mdi mdi-arrow-expand-all" },
                                on: {
                                  click: function ($event) {
                                    return fullScreenSlotProps.onFullScreenToggle()
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c(_setup.StepPager, {
                                attrs: {
                                  disabled:
                                    !_setup.isValid ||
                                    _setup.matchedLoans.length == 0,
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            _setup.Splitter,
                            {
                              staticClass: "main-content",
                              attrs: { panes: _setup.panes },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "splitter-content" },
                                [
                                  _c(
                                    _setup.Grid,
                                    {
                                      key: "matched-loans-count",
                                      staticClass: "grow",
                                      attrs: {
                                        "row-data": _setup.matchedLoansCount,
                                        "export-filename":
                                          "Matched Loans Count Export",
                                        "get-context-menu-items":
                                          _setup.contextMenuItems,
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "toolbar-actions",
                                            fn: function (props) {
                                              return [
                                                _c(
                                                  "div",
                                                  { staticClass: "title" },
                                                  [_vm._v("Matching Criteria")]
                                                ),
                                                _vm._v(" "),
                                                _c("div", {
                                                  staticClass: "grow",
                                                }),
                                                _vm._v(" "),
                                                _c(_setup.Action, {
                                                  staticClass: "ml",
                                                  attrs: {
                                                    icon: "mdi mdi-microsoft-excel",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return props.exportToExcel()
                                                    },
                                                  },
                                                }),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    },
                                    [
                                      _vm._v(" "),
                                      _c("grid-column", {
                                        attrs: {
                                          field: "loan",
                                          filter: "agTextColumnFilter",
                                          "floating-filter": true,
                                          flex: 1,
                                          width: 100,
                                          "header-name": "Matched",
                                          "cell-class": _setup.cellClass,
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("grid-column", {
                                        attrs: {
                                          field: "loanCount",
                                          filter: "agTextColumnFilter",
                                          "floating-filter": true,
                                          width: 70,
                                          "header-name": "Count",
                                          "cell-class": _setup.cellClass,
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "splitter-content" },
                                [
                                  _c(
                                    _setup.Grid,
                                    {
                                      key: "matched-loans",
                                      staticClass: "grow",
                                      attrs: {
                                        "row-data": _setup.matchedLoans,
                                        "export-filename":
                                          "Matched Loans Export",
                                        "get-context-menu-items":
                                          _setup.contextMenuItems,
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "toolbar-actions",
                                            fn: function (props) {
                                              return [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "title font-bold",
                                                  },
                                                  [_vm._v("Loans Found")]
                                                ),
                                                _vm._v(" "),
                                                _c("div", {
                                                  staticClass: "grow",
                                                }),
                                                _vm._v(" "),
                                                _c(_setup.Action, {
                                                  staticClass: "ml",
                                                  attrs: {
                                                    icon: "mdi mdi-microsoft-excel",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return props.exportToExcel()
                                                    },
                                                  },
                                                }),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    },
                                    [
                                      _vm._v(" "),
                                      _c("grid-column", {
                                        attrs: {
                                          flex: 1,
                                          field: "centricityLoanId",
                                          filter: "agTextColumnFilter",
                                          "floating-filter": true,
                                          width: 120,
                                          "header-name": "Centricity Loan Id",
                                          "cell-class": _setup.cellClass,
                                        },
                                      }),
                                      _vm._v(" "),
                                      _setup.isColumnExists("clientLoanID")
                                        ? _c("grid-column", {
                                            attrs: {
                                              flex: 1,
                                              field: "customerLoanId",
                                              filter: "agTextColumnFilter",
                                              "floating-filter": true,
                                              width: 120,
                                              "header-name": "Customer Loan Id",
                                              "cell-class": _setup.cellClass,
                                            },
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _setup.isColumnExists("sellerLoanId")
                                        ? _c("grid-column", {
                                            attrs: {
                                              flex: 1,
                                              field: "sellerLoanId",
                                              filter: "agTextColumnFilter",
                                              "floating-filter": true,
                                              width: 120,
                                              "header-name": "Seller Loan Id",
                                              "cell-class": _setup.cellClass,
                                            },
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c("grid-column", {
                                        attrs: {
                                          field: "buyerName",
                                          filter: "agTextColumnFilter",
                                          "floating-filter": true,
                                          width: 120,
                                          "header-name": "Buyer Name",
                                          "cell-class": _setup.cellClass,
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("grid-column", {
                                        attrs: {
                                          field: "sellerName",
                                          filter: "agTextColumnFilter",
                                          "floating-filter": true,
                                          width: 120,
                                          "header-name": "Seller Name",
                                          "cell-class": _setup.cellClass,
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "splitter-content" },
                                [
                                  _c(
                                    _setup.Grid,
                                    {
                                      key: "un-matched-loans",
                                      staticClass: "grow",
                                      attrs: {
                                        "row-data": _setup.unMatchedLoans,
                                        "export-filename":
                                          "Unmatched Loans Export",
                                        "get-context-menu-items":
                                          _setup.contextMenuItems,
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "toolbar-actions",
                                            fn: function (props) {
                                              return [
                                                _c(
                                                  "div",
                                                  { staticClass: "title" },
                                                  [_vm._v("Problem Loans")]
                                                ),
                                                _vm._v(" "),
                                                _c("div", {
                                                  staticClass: "grow",
                                                }),
                                                _vm._v(" "),
                                                _c(_setup.Action, {
                                                  staticClass: "ml",
                                                  attrs: {
                                                    icon: "mdi mdi-microsoft-excel",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return props.exportToExcel()
                                                    },
                                                  },
                                                }),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    },
                                    [
                                      _vm._v(" "),
                                      _c("grid-column", {
                                        attrs: {
                                          flex: 1,
                                          field: "centricityLoanId",
                                          filter: "agTextColumnFilter",
                                          "floating-filter": true,
                                          width: 120,
                                          "header-name":
                                            "Provided Centricity Loan Id",
                                          "cell-class": _setup.cellClass,
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("grid-column", {
                                        attrs: {
                                          flex: 1,
                                          field: "description",
                                          filter: "agTextColumnFilter",
                                          "floating-filter": true,
                                          width: 120,
                                          "header-name": "Description",
                                          "cell-class": _setup.cellClass,
                                        },
                                      }),
                                      _vm._v(" "),
                                      _setup.isColumnExists("clientLoanID")
                                        ? _c("grid-column", {
                                            attrs: {
                                              flex: 1,
                                              field: "customerLoanId",
                                              filter: "agTextColumnFilter",
                                              "floating-filter": true,
                                              width: 120,
                                              "header-name": "Customer Loan Id",
                                              "cell-class": _setup.cellClass,
                                            },
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _setup.isColumnExists("sellerLoanId")
                                        ? _c("grid-column", {
                                            attrs: {
                                              flex: 1,
                                              field: "sellerLoanId",
                                              filter: "agTextColumnFilter",
                                              "floating-filter": true,
                                              width: 120,
                                              "header-name": "Seller Loan Id",
                                              "cell-class": _setup.cellClass,
                                            },
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _setup.isColumnExists("servicerLoanId")
                                        ? _c("grid-column", {
                                            attrs: {
                                              flex: 1,
                                              field: "servicerLoanId",
                                              filter: "agTextColumnFilter",
                                              "floating-filter": true,
                                              width: 120,
                                              "header-name": "Servicer Loan Id",
                                              "cell-class": _setup.cellClass,
                                            },
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c("grid-column", {
                                        attrs: {
                                          field: "buyerName",
                                          filter: "agTextColumnFilter",
                                          "floating-filter": true,
                                          width: 120,
                                          "header-name": "Buyer Name",
                                          "cell-class": _setup.cellClass,
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("grid-column", {
                                        attrs: {
                                          field: "sellerName",
                                          filter: "agTextColumnFilter",
                                          "floating-filter": true,
                                          width: 120,
                                          "header-name": "Seller Name",
                                          "cell-class": _setup.cellClass,
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]
                          ),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  3348414193
                ),
              }),
            ],
            1
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }